import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/sign-in_/callback')({
  staticData: { team: 'users-infra' },
});
